import { render, staticRenderFns } from "./MediaImage.vue?vue&type=template&id=a8623a42&scoped=true"
import script from "./MediaImage.vue?vue&type=script&lang=js"
export * from "./MediaImage.vue?vue&type=script&lang=js"
import style0 from "./MediaImage.vue?vue&type=style&index=0&id=a8623a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8623a42",
  null
  
)

export default component.exports